module.exports = __webpack_public_path__ + "images/hobby.ac1f2bbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/EbaySweden.TouchWeb/static/images/category-carousel/hobby.jpg
// module id = edeaf1c6
// module chunks = 10 37